import httpService from '../../http'
import api from '../../api'
import helpers from '../../helpers'
const apiModule = api.groups
const errorsStr = helpers.error.errors
const mapper = helpers.mapper

function getModel () {
  return {
    id: {
      data: 'id',
      title: 'ID',
      value: null,
      type: null,
      order: 'desc',
      showOrder: true
    },
    createdAt: {
      data: 'createdAt',
      title: 'Дата создания',
      value: null,
      type: 'datetime',
      order: null,
      showOrder: true
    },
    updatedAt: {
      data: 'updatedAt',
      title: 'Дата последнего обновления',
      value: null,
      type: 'datetime',
      order: null,
      showOrder: true
    },
    name: {
      data: 'name',
      title: 'Название',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    promocode: {
      data: 'promocode',
      title: 'Промокод',
      value: null,
      type: null
    },
    sale: {
      data: 'sale',
      title: 'Скидка',
      value: 0,
      type: 'sale',
      order: null,
      showOrder: true
    },
    dealerId: {
      data: 'dealerId',
      title: 'ID владельца',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    dealerIdMysql: {
      data: 'dealerIdMysql',
      title: 'ID владельца MySql',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    dealerName: {
      data: 'dealerName',
      title: 'Имя владельца',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    usersCount: {
      data: 'usersCount',
      title: 'К-во пользователей',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    ordersPrice: {
      data: 'ordersPrice',
      title: 'Сумма заказов, руб.',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    ordersCount: {
      data: 'ordersCount',
      title: 'К-во заказов',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    ordersBonus: {
      data: 'ordersBonus',
      title: 'Сумма потраченных бонусов, бал.',
      value: null,
      type: null,
      order: null,
      showOrder: true
    },
    groupEvents: {
      data: 'groupEvents',
      title: 'Участие',
      value: null,
      type: 'checkbox',
      order: null,
      showOrder: true,
      handler: function (data) {
        if (data.groupEvents) return true
        else return false
      }
    }

  }
};

function role () { return localStorage.getItem('role') };

const state = {
  model: getModel(),
  id: null,
  userId: null,
  show: 'all',
  question: getModel(),
  questions: [],
  errMain: null,
  errors: {
    name: null,
    sale: null
  },
  promocode: null,
  tabs: {
    admin: {
      group: {
        data: 'group',
        title: 'Группа',
        active: true
      },
      promocode: {
        data: 'promocode',
        title: 'Промокод',
        active: false
      },
      users: {
        data: 'users',
        title: 'Участники',
        active: false
      }
    },
    dealer: {
      group: {
        data: 'group',
        title: 'Группа',
        active: true
      },
      promocode: {
        data: 'promocode',
        title: 'Промокод',
        active: false
      },
      users: {
        data: 'users',
        title: 'Участники',
        active: false
      }
    }
  },
  filters: {
    names: [],
    dealersId: [],
    dealersName: []
  },
  filtersQuery: {},
  isFilter: false,
  showFilters: false
}
const getters = {
  getModel (state) { return state.model },
  getId (state) { return state.id },
  getUserId (state) { return state.userId },
  getShow (state) { return state.show },
  getOne (state) { return state.question },
  getAll (state) { return state.questions },
  getErrors (state) { return state.errors },
  getErrMain (state) { return state.errMain },
  getTabs (state) { return state.tabs[role()] },
  getPromocodeId (state) { return state.promocode },
  getFilters (state) { return state.filters },
  getFiltersQuery (state) { return state.filtersQuery },
  getShowFilters (state) { return state.showFilters },
  getIsFilter (state) { return state.isFilter }
}
const mutations = {
  setModel (state, data) { state.model = data },
  setId (state, data) { state.id = data },
  setUserId (state, data) { state.userId = data },
  setShow (state, data) { state.show = data },
  setOne (state, data) { state.question = data },
  setAll (state, data) { state.questions = data },
  setErrors (state, data) { state.errors[data.param] = data.value },
  setErrMain (state, data) { state.errMain = data },
  setTab (state, data) { state.tabs[role()][data.param].active = data.value },
  setPromocode (state, data) { state.promocode = data },
  setOrder (state, data) {
    for (let param in state.model) {
      if (state.model[param].order && state.model[param].showOrder && state.model[param] != state.model[data.param]) state.model[param].order = null
    };
    let order = state.model[data.param].order
    if (!order) order = 'desc'
    else if (order == 'desc') order = 'asc'
    else if (order == 'asc') order = null
    state.model[data.param].order = order
  },
  setFilters (state, data) { state.filters = data },
  setFiltersQuery (state, data) { state.filtersQuery = data },
  resetFiltersQuery (state) { state.filtersQuery = {} },
  setShowFilters (state, data) { state.showFilters = data },
  setIsFilter (state, data) { state.isFilter = data }
}
const actions = {
  setActiveTab ({ commit, state }, data) {
    let param = data.param
    let tabs = state.tabs[role()]
    for (let tab in tabs) {
      if (param == tab) commit('setTab', { param: tab, value: true })
      else commit('setTab', { param: tab, value: false })
    };
  },
  setModelRequired ({ commit }, data) {
    commit('setModel', mapper.modelRequired(data.required, getModel()))
  },
  resetAllErr ({ state, commit }) {
    commit('setErrMain', null)
    let errors = state.errors
    if (errors) {
      for (let err in errors) {
        commit('setErrors', { param: err, value: null })
      };
    };
  },
  sendErrMain ({ commit }, data) {
    console.log(data)
    commit('setErrMain', httpService.error(data))
  },
  toAdd ({ commit }) {
    commit('setId', null)
    commit('setShow', 'one')
  },
  toUpdate ({ commit }, data) {
    commit('setId', data.id)
    commit('setShow', 'one')
  },
  toAll ({ commit }) {
    commit('setId', null)
    commit('setShow', 'all')
    commit('setOne', getModel())
  },
  async getOne ({ state, commit, dispatch }, data) {
    try {
      dispatch('resetAllErr')
      if (state.id) {
        let result = await httpService.get(apiModule[role()].getOne, { id: state.id })
        result.data.data.sale = result.data.data.sale * 100
        let promocode = result.data.data.promocode
        // if(promocode && promocode.id) commit('setPromocode', {id: promocode.id, name: promocode.name});
        if (promocode && promocode.id) {
          promocode.sale = promocode.sale * 100
          commit('setPromocode', promocode)
        } else commit('setPromocode', null)
        commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async getAll ({ state, commit, dispatch }, data) {
    try {
      let order = []
      let model = state.model
      for (let param in model) {
        if (model[param].order) order.push(`${model[param].data},${model[param].order}`)
      };
      data.params.order = order
      let result = await httpService.get(apiModule[role()].getAll, data.params)
      commit('setAll', result)
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async createOrUpdate ({ state, commit, dispatch }, data) {
    try {
      let dataNew = mapper.dataToRequest(data.data)
      if (!dataNew.name) commit('setErrors', { param: 'name', value: errorsStr.empty })
      if (!dataNew.sale) dataNew.sale = 0
      if (dataNew.sale < 0) commit('setErrors', { param: 'sale', value: errorsStr.lessThanZero })
      if (dataNew.sale > 100) commit('setErrors', { param: 'sale', value: errorsStr.moreThanHundred })
      dataNew.sale = dataNew.sale / 100
      let owner = data.owner
      if (owner) {
        // let dealerIdMysql = owner.split(' ИМЯ: ')[0].split('ID: ')[1];
        // let dealerName = owner.split(' ИМЯ: ')[1];

        let dealerIdMysql = owner.ID
        let dealerName = owner.NAME

        if (dealerIdMysql) dataNew.dealerIdMysql = dealerIdMysql
        if (dealerName) dataNew.dealerName = dealerName
      }
      let isErr = false
      for (let error in state.errors) {
        if (state.errors[error]) isErr = true
      };
      delete dataNew.createdAt
      delete dataNew.updatedAt
      delete dataNew.promocode
      delete dataNew.users
      if (!isErr) {
        let result = getModel()
        if (!state.id) result = await httpService.post(apiModule.admin.add, dataNew)
        else result = await httpService.patch(apiModule[role()].update, dataNew)
        commit('setId', result.data.data.id)
        result.data.data.sale = result.data.data.sale * 100
        commit('setOne', mapper.dataToView(data.required, getModel(), result.data.data))
        let promocode = result.data.data.promocode
        if (promocode) promocode.sale = promocode.sale * 100
        if (promocode && promocode.id) commit('setPromocode', promocode)
        dispatch('resetAllErr')
      };
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async delete ({ state, dispatch }) {
    try {
      await httpService.delete(apiModule.admin.delete, { id: state.id })
      dispatch('toAll')
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  },
  async getFilters ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(apiModule[role()].getFilters, data.params)
      commit('setFilters', result.data)
    } catch (err) {
      dispatch('sendErrMain', err)
    };
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
